import * as React from 'react';
import BaseAnimation from './BaseAnimation';

const BackgroundAnimation = (props: $TSFixMe) => {
    const { children, active, start, end, duration = 400 } = props;
    const style = {
        ...props.style,
        transitionProperty: 'background',
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: 'cubic-bezier(0.65, 0, 0.35, 1)',
        background: active ? end || start : start
    };

    return (
        <BaseAnimation {...props} style={style} hideChildren={false}>
            {children}
        </BaseAnimation>
    );
};

export default BackgroundAnimation;
